import moment from "moment";
import click from "../assets/images/click.svg";
import cash_icon from "../assets/images/cash_icon.svg";
import trade from "../assets/images/trade.svg";
import cash_inactive from "../assets/images/cash_inactive.svg";
import trade_inactive from "../assets/images/trade_inactive.svg";
import click_inactive from "../assets/images/click_inactive.svg";
import chequeGreen from "../assets/images/chequegreen.svg";
import chequeRed from "../assets/images/chequered.svg";
import pfGreen from "../assets/images/AgreementGreen.svg";
import pfGradeOut from "../assets/images/Agreementgrade.svg";
import timer from "../assets/images/timer-img.png";
import disburse from "../assets/images/disbursed.svg";
import reject from "../assets/images/reject.svg";
import approved from "../assets/images/approvedTick.svg";
import { cropPackagingOptions } from "./trade";

export function getCurrencyNumberWithSymbol(number, allowZero = false) {
  if (allowZero && number == 0) {
    return "₹0";
  }
  return number == null || number == 0
    ? ""
    : number.toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      });
}
export function gettingCurrencyNumberWithOutSymbol(number, allowZero = false) {
  if (allowZero && number === 0) {
    return "0";
  }
  return number == null || number === 0
    ? ""
    : number
        .toLocaleString("en-IN", {
          maximumFractionDigits: 2,
          style: "currency",
          currency: "INR",
        })
        .replace("₹", "");
}

export function getCurrencyNumberWithOutSymbol(number) {
  return number == null || number == 0
    ? ""
    : number
        .toLocaleString("en-IN", {
          maximumFractionDigits: 2,
          style: "currency",
          currency: "INR",
        })
        .replace("₹", "");
}
export function getCurrencyNumberWithOneDigit(number) {
  return number == null || number == 0 ? "" : number.toFixed(1);
}
export function getCurrencyNumberForWastage(number) {
  return number == null || number == 0 ? "" : number;
}
export function getMaskedMobileNumber(number) {
  return number?.replace(/.(?=.{4})/g, "X");
}
export function getQuantityData(qty, qtyUnit, weight) {
  var qtyData = {
    majorUnitVal: `${
      (qty === 0 ? "" : getCurrencyNumberWithOneDigit(qty)) +
      (qtyUnit.toLowerCase() === "loads" ||
      qtyUnit.toLowerCase() === "pieces" ||
      qtyUnit.toLowerCase() === "kgs"
        ? ""
        : " " + getCropUnit(qtyUnit))
    } ${
      qty === 0 || qty === null
        ? ""
        : weight === 0 || weight === null
          ? ""
          : " | "
    }`,
    minorUnitVal:
      getCurrencyNumberWithOneDigit(weight) +
      (qtyUnit.toLowerCase() === "loads" ||
      qtyUnit.toLowerCase() === "pieces" ||
      qtyUnit.toLowerCase() === "kgs"
        ? getCropUnit(qtyUnit)
        : weight === 0 || weight === null
          ? ""
          : " KGS"),
  };
  return qtyData;
}
const getCropUnit = (unit) => {
  var unitType = "";
  switch (unit.toLowerCase()) {
    case "crates":
      unitType = "C";
      break;
    case "boxes":
      unitType = "BX";
      break;
    case "bags":
      unitType = "BG";
      break;
    case "sacs":
      unitType = "S";
      break;
    case "loads":
      unitType = "LDS";
      break;
    case "pieces":
      unitType = "PCS";
      break;
    case "kgs":
      unitType = "KGS";
      break;
    default:
      unitType = "KGS";
      break;
  }
  return unitType;
};
export function getWastage(wastage, qtyUnit, rateType) {
  return `${
    wastage !== 0
      ? wastage !== null
        ? " - " +
          getCurrencyNumberWithOneDigit(wastage) +
          (qtyUnit.toLowerCase() === "pieces"
            ? getCropUnit(qtyUnit)
            : qtyUnit.toLowerCase() === "loads"
              ? ""
              : rateType === "RATE_PER_KG"
                ? "KGS"
                : getCropUnit(qtyUnit))
        : ""
      : ""
  }`;
}
export function totalBagsValue(bags) {
  var totalValue = 0;
  bags.map((item) => {
    totalValue += item.weight;
  });
  return parseFloat(totalValue.toFixed(2));
}
export function isEditBillStatus(date, settingsDate) {
  if (date != "") {
    var currentDate = moment(new Date());
    var billDateVal = moment(new Date(date));
    var days_diff = currentDate.diff(billDateVal, "days");
    if (days_diff < settingsDate) {
      return true;
    }
  }
  return false;
}
export function getTimeformat12(timeString) {
  if (!timeString) {
    return "";
  }
  const [hourString, minute] = timeString?.split(":");
  const hour = +hourString % 24;
  return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
}
export function number2words(n) {
  var num =
    "zero one two three four five six seven eight nine ten eleven twelve thirteen fourteen fifteen sixteen seventeen eighteen nineteen".split(
      " ",
    );
  var tens = "twenty thirty forty fifty sixty seventy eighty ninety".split(" ");

  if (n < 20) return num[n];
  var digit = n % 10;

  if (n < 100)
    return tens[Math.floor(n / 10) - 2] + (digit ? "-" + num[digit] : "");

  if (n < 1000)
    return (
      num[Math.floor(n / 100)] +
      " hundred" +
      (n % 100 == 0 ? "" : " " + number2words(n % 100))
    );

  if (n < 100000)
    return (
      number2words(Math.floor(n / 1000)) +
      " thousand" +
      (n % 1000 != 0 ? " " + number2words(n % 1000) : "")
    );

  if (n < 10000000)
    return (
      number2words(Math.floor(n / 100000)) +
      " lakh" +
      (n % 100000 != 0 ? " " + number2words(n % 100000) : "")
    );

  if (n < 1000000000)
    return (
      number2words(Math.floor(n / 10000000)) +
      " crore" +
      (n % 10000000 != 0 ? " " + number2words(n % 10000000) : "")
    );

  return "Number too large"; // Catch-all for very large numbers
}

export function numberToWordsWithDecimals(amount) {
  const integerPart = Math.floor(amount);
  const decimalPart = Math.round((amount - integerPart) * 100); // Get decimal part as whole number

  let words = number2words(integerPart) + " rupees"; // Add "rupees" after the integer part

  if (decimalPart > 0) {
    words += " and " + number2words(decimalPart) + " paise"; // Handle decimal part with "paise"
  } else {
    words += " only"; // Add "only" if there are no decimal points
  }

  return toCamelCase(words);
}
function toCamelCase(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const calculateTotal = (
  values,
  withCurrency = false,
  roundOff = false,
  inCrores = false,
) => {
  const total = values
    .filter((value) => typeof value === "number" && !isNaN(value))
    .reduce((acc, value) => acc + value, 0);

  if (total == null || total === 0) {
    return "--";
  }

  let finalTotal = total;

  if (roundOff) {
    finalTotal = withCurrency
      ? Math.round(total * 100) / 100
      : Math.round(total);
  }

  // Crore logic
  if (inCrores && total >= 10000000) {
    const croreValue = (total / 10000000).toFixed(2);
    return withCurrency ? `₹${croreValue} Cr` : `${croreValue} Cr`;
  }

  // Default format
  if (withCurrency) {
    return finalTotal.toLocaleString("en-IN", {
      maximumFractionDigits: roundOff ? 0 : 2,
      style: "currency",
      currency: "INR",
    });
  } else {
    return finalTotal.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
    });
  }
};

export function getCurrencyNumberWithouDecimal(number) {
  return number == null || number == 0
    ? ""
    : number.toLocaleString("en-IN", {});
}
export function getProductIcons(name) {
  if (name == "CLICK") {
    return click;
  } else if (name === "TRADE") {
    return trade;
  } else if (name === "CASH") {
    return cash_icon;
  } else {
    return "";
  }
}
export function getProductInactiveIcons(name) {
  if (name == "CLICK") {
    return click_inactive;
  } else if (name === "TRADE") {
    return trade_inactive;
  } else if (name === "CASH") {
    return cash_inactive;
  } else {
    return "";
  }
}
export let commoditySizes = [
  { label: "Golta / Golti", value: "GOLTA_GOLTI" },
  { label: "Golti (25mm to 35mm)", value: "GOLTI" },
  { label: "Golta (35mm to 45mm)", value: "GOLTA" },
  { label: "Medium (45mm to 55mm)", value: "MEDIUM" },
  { label: "Mini Mukkal (50mm to 60mm)", value: "MINI_MUKKAL" },
  { label: "Mukkal (55mm to 60mm)", value: "MUKKAL" },
  { label: "Large (60mm to 70mm)", value: "LARGE" },
  { label: "Extra Large (70mm+)", value: "EXTRA" },
  { label: "Family Pack (Varied Sizes)", value: "FAMILY_PACK" },
];

// export let commodityPackaging = [
//   { label: "Jute Bag", value: "JUTE_BAG" },
//   { label: "Mesh Bag", value: "MESH_BAG" },
// ];

export let commodityQualtiy = [
  { label: "Premium", value: "PREMIUM" },
  { label: "Best", value: "BEST" },
  { label: "Average", value: "AVERAGE" },
  { label: "Super Average", value: "SUPER_AVERAGE" },
];
export function getSizeText(value) {
  let text = "";
  let size = commoditySizes.find((size) => size.value === value);
  if (size) {
    text = size.label;
  }
  return text;
}

export function getPackagingText(value) {
  let text = "";
  let size = cropPackagingOptions.find((size) => size.value === value);
  if (size) {
    text = size.label;
  }
  return text;
}

export function getQualityGradeText(value) {
  let text = "";
  let size = commodityQualtiy.find((size) => size.value === value);
  if (size) {
    text = size.label;
  }
  return text;
}
export function formatCrWithRupee(value) {
  const num = Number(value);

  if (isNaN(num)) return value;

  if (num >= 1e7) {
    return "₹" + (num / 1e7).toFixed(2) + " Cr";
  }

  return "₹" + num.toLocaleString("en-IN");
}
export function getCurrenyNumberWithRoundoff(number, allowZero = false) {
  if (allowZero && number == 0) {
    return "₹0";
  }

  if (number == null || number == 0) {
    return "";
  }

  const rounded = Math.round(number);

  // If >= 1 crore
  if (rounded >= 10000000) {
    const croreValue = (rounded / 10000000).toFixed(2);
    return `₹${croreValue} Cr`;
  }

  return rounded.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  });
}

export function formatLabel(str) {
  const spaced = str.replace(/(\d+)([A-Z][a-z]+)/, "$1 $2");

  return spaced
    .split(" ")
    .map((word, i) =>
      i === 0
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ");
}
export function fixedDigitNumber(number, digits = 2) {
  return parseFloat(number.toFixed(digits));
}
export function getTradeType(tradeType) {
  let value = "";
  if (tradeType == "DEST") {
    value = "Buy(Destination Trader)";
  } else if (tradeType == "SOURCE") {
    value = "Sell(Source Trader)";
  } else if (tradeType == "DUAL") {
    value = "Both (Sell & Buy)";
  }
  return value;
}

export function getQualityGradeTooltipText(value) {
  let text = value;
  if (text == "PREMIUM") {
    text =
      "Double Patti is a minimum standard and up to 2% deviation can be accepted.";
  } else if (text == "BEST") {
    text =
      "Double Patti is a minimum standard and up to 2% deviation can be accepted.";
  } else if (text == "AVERAGE") {
    text =
      "Single Patti, Varied Sizes, Skinouts, Rottened, Black Spots, Sprouts etc. and up to 2% deviation can be accepted.";
  } else if (text == "SUPER_AVERAGE") {
    text =
      "Skinouts, Rotten, Black Spots etc. are not recommended to send for long distance. You may incur heavy losses.";
  }
  return text;
}
export function getQtyTypeText(type) {
  let text = "";
  if (type == "TON") {
    text = "Tons";
  }

  return text;
}

export function getSrcChequeIcon(status) {
  switch (status) {
    case "VALID":
      return <img src={chequeGreen} className="w-6 h-6" />;
    case "EXPIRED":
      return <img src={chequeRed} className="w-6 h-6" />;
    case "":
      return <span></span>;
    default:
      return null;
  }
}

export function getDestChequeIcon(status) {
  switch (status) {
    case "VALID":
      return <img src={chequeGreen} className="w-6 h-6" />;
    case "EXPIRED":
      return <img src={chequeRed} className="w-6 h-6" />;
    case "":
      return <span></span>;
    default:
      return null;
  }
}

export function getSrcPfAgree(status) {
  switch (status) {
    case "ACTIVE":
      return <img src={pfGreen} className="w-7 h-7" />;
    case "INVITED":
      return <img src={pfGradeOut} className="w-7 h-7" />;
    case "":
      return <span></span>;
    default:
      return null;
  }
}

export function getDestPfAgree(status) {
  switch (status) {
    case "ACTIVE":
      return <img src={pfGreen} className="w-7 h-7" />;
    case "INVITED":
      return <img src={pfGradeOut} className="w-7 h-7" />;
    case "":
      return <span></span>;
    default:
      return null;
  }
}
export function getAppStatus(value) {
  if (value === "PENDING") {
    return (
      <div className="flex gap-1">
        <img src={timer} className="w-5 h-5" />{" "}
        <span className="color-orange">Pending</span>
      </div>
    );
  } else if (value === "APPROVED") {
    return (
      <div className="flex gap-1">
        <img src={approved} className="w-5 h-5" />
        <span className="color-primary">Approved</span>
      </div>
    );
  } else if (value === "DISBURSED") {
    return (
      <div className="flex gap-1">
        <img src={disburse} className="w-5 h-5" />
        <span className="color-primary">Disbursed</span>
      </div>
    );
  } else if (value === "REJECTED") {
    return (
      <div className="flex gap-1">
        <img src={reject} className="w-5 h-5" />
        <span className="color-red">Rejected</span>
      </div>
    );
  } else if (value === "REVALIDATE") {
    return (
      <div className="flex gap-1">
        <img src={timer} className="w-5 h-5" />{" "}
        <span className="color-orange">Revalidate</span>
      </div>
    );
  } else if (value === "CLOSED") {
    return (
      <div className="flex gap-1">
        <img src={timer} className="w-5 h-5" />{" "}
        <span className="color-orange">Closed</span>
      </div>
    );
  }
  return value;
}
export function getRatePerUnit(rateType) {
  let value = "";

  if (rateType == "RATE_PER_KG") {
    value = "Per Kg";
  } else if (rateType == "RATE_PER_UNIT") {
    value = "Per Unit";
  } else if (rateType == "RATE_PER_TON") {
    value = "Per Ton";
  } else if (rateType == "RATE_PER_PIECE") {
    value = "Per Piece";
  } else if (rateType == "RATE_PER_TRUCK") {
    value = "Per Truck";
  }
  return value;
}
export function getRateType(rateType) {
  let value = "";

  if (rateType === "SPOT") {
    value = "Spot Rate";
  } else if (rateType === "LANDING") {
    value = "Landing Rate";
  }
  return value;
}
export function getQtyPerUnitType(rateType) {
  let value = "";

  if (rateType == "CRATES") {
    value = "Crates";
  } else if (rateType == "BAGS") {
    value = "Bags";
  } else if (rateType == "BOXES") {
    value = "Boxes";
  } else if (rateType == "SACS") {
    value = "Sacs";
  } else if (rateType == "PIECES") {
    value = "Pieces";
  } else if (rateType == "LOADS") {
    value = "Loads";
  }
  return value;
}
export function hasSrcDestPfAgree(status) {
  return status === "ACTIVE" || status === "INVITED";
}

export function excelNumberCell(value) {
  if (value === "" || value === null || value === undefined) {
    return "";
  }

  const numberValue = Number(String(value).replace(/[₹,\s]/g, ""));

  return {
    v: Number.isFinite(numberValue) ? numberValue : 0,
    t: "n",
    z: "0",
  };
}
export const formatDateVal = (date) => {
  if (!date?.trim()) return "";
  const formattedDate = moment(date);
  return formattedDate.isValid() ? formattedDate.format("DD-MMM-YYYY") : "";
};

export function getKycStatus(status) {
  const normalizedStatus = status?.trim().toUpperCase();

  const isCompleted =
    normalizedStatus === "KYC_COMPLETED" ||
    normalizedStatus === "CONSENT_COMPLETED";

  const label = status
    ? status
        .trim()
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
    : "";

  const icon = isCompleted ? approved : timer;

  return (
    <div
      className={`flex items-center gap-1 ${
        isCompleted ? "color-primary" : "color-orange"
      }`}
    >
      {" "}
      <img src={icon} className="w-5 h-5" alt="" /> <span>{label}</span>{" "}
    </div>
  );
}
export const genderOptions = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
];

export default {
  getSrcChequeIcon,
  getDestChequeIcon,
  getSrcPfAgree,
  getDestPfAgree,
  getCurrencyNumberWithSymbol,
  getCurrencyNumberWithOutSymbol,
  getCurrencyNumberWithOneDigit,
  getMaskedMobileNumber,
  getQuantityData,
  getWastage,
  totalBagsValue,
  isEditBillStatus,
  getTimeformat12,
  number2words,
  numberToWordsWithDecimals,
  calculateTotal,
  getCurrencyNumberWithouDecimal,
  getProductIcons,
  getProductInactiveIcons,
  formatCrWithRupee,
  getCurrenyNumberWithRoundoff,
  formatLabel,
  fixedDigitNumber,
  getSizeText,
  getPackagingText,
  getQualityGradeText,
  getTradeType,
  getQualityGradeTooltipText,
  getQtyTypeText,
  gettingCurrencyNumberWithOutSymbol,
  getAppStatus,
  getRatePerUnit,
  getRateType,
  hasSrcDestPfAgree,
  getKycStatus,
};
